import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Voter } from './Voter';
import { VoterItemSetWidget } from './VoterItemSetWidget';
import { VoterSoundWidget } from './VoterSoundWidget';

export const voterPropertyLayout = LockablePropertyStripLayout<Voter>((d, s, o, w, a) => [
    //
    // Configure Items
    w.createPopout({
        facade: a,
        image: 'deqo://icons/hero/cog',
        text: 'Configure Items',
        ui: VoterItemSetWidget,
        autoClose: false,
        onSelect() { }
    }),
    //
    // Sound
    w.createPopout({
        image: 'deqo://icons/hero/music-note',
        text: 'Voter Sound',
        value: a.get('sound'),
        ui: VoterSoundWidget,
        onSelect() {
            o.update(() => {
                a.set('sound', this.value);
            });
        }
    }),
    w.createDivide(),
    //
    // More
    ...lockAndMoreLayout(d, s, o, w, a),
]);
